import { FC } from 'react';
import GroupSearch from '../GroupSearch';
import SearchFormItem from './subpage/searchFormItem';
import { GroupSearchProps } from '../GroupSearch/interface';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';

export interface SearchFormGroupSearchProps extends BaseSearchFormItemProps {
  /** GroupSearch Props */
  groupSearchProps?: GroupSearchProps;
}
/** 下拉+匹配类型+多行输入框 组合搜索 */
export const SearchFormGroupSearch: FC<SearchFormGroupSearchProps> = props => {
  const {
    groupSearchProps,
    isDetail,
    form,
    render,
    disabledRender,
    isTable,
    name,
    testId,
    label,
    rules,
    copy,
    ...resProps
  } = props;
  return (
    <SearchFormItem
      {...resProps}
      disabled={isDetail || groupSearchProps?.disabled}
      name={name}
      label={label}
      rules={rules}
    >
      <GroupSearch
        test-id={`${testId}-${name}`}
        {...groupSearchProps}
        disabled={isDetail || groupSearchProps?.disabled}
      />
    </SearchFormItem>
  );
};

SearchFormGroupSearch.displayName = SearchFormItemEnum.SearchFormGroupSearch;

export default SearchFormGroupSearch;
